import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {FormGroup, Input, Label} from "reactstrap"
import {filterStatus} from "../../helpers/skuFilter"

class FilterStatus extends Component {
    _handleChangeStatus = (e) => {
        const {name, value} = e.target
        const {onChangeFilter} = this.props

        if (typeof onChangeFilter === 'function') {
            onChangeFilter(name, value)
        }
    }

    render() {
        const {status} = this.props

        return (
            <div className="FilterStatus">
                <FormGroup>
                    <Label className='font-weight-bold'>Trạng thái </Label>
                    <Input type='select' value={status} name='is_active' onChange={this._handleChangeStatus}>
                        {
                            filterStatus.map(item => {
                                return <option key={item.value} value={item.value}>{item.name}</option>
                            })
                        }
                    </Input>
                </FormGroup>
            </div>
        )
    }
}

FilterStatus.propTypes = {
    status: PropTypes.any,
    onChangeFilter: PropTypes.func
}

export default FilterStatus